<div class="tw-p-5">
    <div
        class="tw-flex"
        [ngClass]="page == 'insurance' ? 'tw-justify-between' : 'tw-justify-end'"
    >
        <div *ngIf="page == 'insurance'" class="tw-font-semibold tw-text-[21px] lg:tw-pl-[30px]">{{ 'REMINDER' | translate }}</div>
        <div (click)="closeDialog()" class="tw-cursor-pointer">
            <mat-icon aria-hidden="false"  aria-label="Example close icon" fontIcon="close"></mat-icon>
        </div>
    </div>
    <div *ngIf="page == 'lndp'">
        <div class="tw-flex tw-flex-col tw-px-[2vw]">
            <div class="tw-w-full tw-text-[18px] sm:tw-text-[18px] lg:tw-text-[32px] tw-font-semibold">{{ type | translate }}</div>
            <div class="tw-pt-[2vw] tw-flex tw-flex-row tw-gap-8 tw-justify-center sm:tw-justify-center lg:tw-justify-left">
                <div class="tw-w-auto tw-hidden lg:tw-block">
                    <iframe
                        width="489"
                        height="385"
                        [src]="urlSafeDesktop"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                    ></iframe>
                    <div class="tw-mt-[10px] tw-font-medium">{{ data?.miniTitle | translate }}</div>
                </div>
                <div class="tw-w-auto tw-block lg:tw-hidden">
                    <iframe
                        width="318"
                        height="167"
                        [src]="urlSafeMobile"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                        style="margin: auto;"
                    ></iframe>
                    <div class="tw-mt-[10px] tw-font-medium tw-text-[12px] tw-text-center">{{ data?.miniTitle | translate }}</div>
                    <div class="tw-block lg:tw-hidden tw-mt-[30px]">
                        <div class="tw-h-[300px] tw-text-[13px] tw-overflow-x-auto">
                            <div>{{ data?.description | translate }}</div>
                            <div class="tw-mt-[20px]">{{ data?.description_1 | translate }}</div>
                            <div [ngClass]="data?.description_1 ? '' : 'tw-mt-[20px]'">{{ data?.otherDescription?.other_1 | translate }}</div>
                            <div [ngClass]="data?.description_1 ? '' : 'tw-mt-[20px]'">{{ data?.otherDescription?.other_2 | translate }}</div>
                            <div [ngClass]="data?.description_1 ? '' : 'tw-mt-[20px]'">{{ data?.otherDescription?.other_3 | translate }}</div>
                            <div [ngClass]="data?.description_1 ? '' : 'tw-mt-[20px]'">{{ data?.otherDescription?.other_4 | translate }}</div>
                            <div class='tw-mt-[20px]'>{{ data?.description_2 | translate }}</div>
                        </div>
                        <div>
                            <a (click)="goToFAQ(type)" class="tw-text-[#1601FF] tw-cursor-pointer tw-text-[12px] tw-font-semibold hover:tw-underline">{{ data?.faq?.header | translate }}</a>
                            <div class="tw-mt-[30px] tw-text-[13px] tw-font-semibold tw-mb-[20px]">{{ data?.topics?.header | translate }}</div>
                            <div class="tw-flex tw-flex-wrap tw-gap-[10px]">
                                <div
                                    *ngFor="let topic of data?.topics?.data"
                                    class="tw-flex tw-border-[#003A70] tw-border-2 tw-border-solid tw-w-max tw-rounded-[32px] tw-h-[29px] tw-items-center tw-px-[15px] tw-py-[14px]"
                                >
                                    <span class="tw-text-[13px] tw-text-[#003A70]">{{ topic | translate }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tw-hidden lg:tw-block tw-w-[40%]">
                    <div class="tw-h-[300px] tw-text-[13px] tw-overflow-x-auto">
                        <div>{{ data?.description | translate }}</div>
                        <div class="tw-mt-[20px]">{{ data?.description_1 | translate }}</div>
                        <div class='tw-mt-[20px]'>{{ data?.description_2 | translate }}</div>
                        <div [ngClass]="data?.description_1 ? '' : 'tw-mt-[20px]'">{{ data?.otherDescription?.other_1 | translate }}</div>
                        <div [ngClass]="data?.description_1 ? '' : 'tw-mt-[20px]'">{{ data?.otherDescription?.other_2 | translate }}</div>
                        <div [ngClass]="data?.description_1 ? '' : 'tw-mt-[20px]'">{{ data?.otherDescription?.other_3 | translate }}</div>
                        <div [ngClass]="data?.description_1 ? '' : 'tw-mt-[20px]'">{{ data?.otherDescription?.other_4 | translate }}</div>
                    </div>
                    <div>
                        <a (click)="goToFAQ(type)" class="tw-text-[#1601FF] tw-cursor-pointer tw-text-[12px] tw-font-semibold hover:tw-underline">{{ data?.faq?.header | translate }}</a>
                        <div class="tw-mt-[30px] tw-text-[13px] tw-font-semibold tw-mb-[20px]">{{ data?.topics?.header | translate }}</div>
                        <div class="tw-flex tw-flex-wrap tw-gap-[10px]">
                            <div
                                *ngFor="let topic of data?.topics?.data"
                                class="tw-flex tw-border-[#003A70] tw-border-2 tw-border-solid tw-w-max tw-rounded-[32px] tw-h-[29px] tw-items-center tw-px-[15px] tw-py-[14px]"
                            >
                                <span class="tw-text-[13px] tw-text-[#003A70]">{{ topic | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-py-[2vw]">
            <p class="tw-text-sm">
                {{"CGC_DEV_PROG_PAGE.COMMENT" | translate}}
            </p>
            <button
                [ga-event-id]="popupGA.event"
                ga-event-category="CGC Dev Programme Page Button"
                [ga-event-label]="popupGA.label"
                ga-track="track"
                (click)="register()"
                class="tw-mt-4 tw-rounded-[32px] tw-text-white tw-font-semibold tw-py-[1.3rem] tw-w-[221px] tw-text-[16px] tw-bg-[#FF8819]"
                type="submit"
            >
                {{ "CGC_DEV_PROG_PAGE.REGISTER_YOUR_INTEREST" | translate }}
            </button>
        </div>
    </div>
    <div *ngIf="page == 'insurance'">
        <div class="figtree tw-p-0 lg:tw-p-[2rem] tw-text-[16px] tw-leading-6 tw-text-[#55555] tw-w-full tw-h-auto">
            <div>{{ 'INSURANCE_PAGE.DISCLAIMER_1' | translate }}</div>
            <div class="tw-pt-[20px]">{{ 'INSURANCE_PAGE.DISCLAIMER_2' | translate }}</div>
            <div class="tw-pt-[20px]">{{ 'INSURANCE_PAGE.DISCLAIMER_3' | translate }}</div>
            <div class="tw-pt-[20px]">{{ 'INSURANCE_PAGE.DISCLAIMER_4' | translate }}</div>
            <div class="tw-pl-[20px] tw-pt-[20px]">{{ 'INSURANCE_PAGE.DISCLAIMER_4.1' | translate }}</div>
            <div class="tw-pl-[20px] tw-pt-[20px]">{{ 'INSURANCE_PAGE.DISCLAIMER_4.2' | translate }}</div>
            <div class="tw-pt-[20px]">{{ 'INSURANCE_PAGE.DISCLAIMER_5' | translate }}</div>

            <div class="tw-flex tw-justify-center tw-pt-[30px]">
                <button
                    [attr.ga-event-id]="popupGA[0].Cancel.event"
                    ga-event-category="Insurance Page Button"
                    [attr.ga-event-label]="popupGA[0].Cancel.label"
                    ga-track="track"
                    class="tw-text-[#8D8D8D] tw-py-[1rem] tw-mt-5 tw-max-h-[56px] tw-rounded-[16px] tw-font-semibold tw-h-full tw-flex tw-justify-center tw-item tw-w-[121px]"
                    type="submit"
                    (click)="closeDialog()"
                >
                    {{ "CANCEL" | translate }}
                </button>
                <button
                    [attr.ga-event-id]="popupGA[0].Proceed.event"
                    ga-event-category="Insurance Page Button"
                    [attr.ga-event-label]="popupGA[0].Proceed.label"
                    ga-track="track"
                    class="tw-py-[1rem] tw-mt-5 tw-max-h-[56px] tw-rounded-[24px] tw-text-white tw-font-semibold tw-bg-[#FFA53C] tw-h-full tw-flex tw-justify-center tw-item tw-w-[130px]"
                    style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);"
                    type="submit"
                    (click)="onSelectProduct()"
                >
                    {{ "PROCEED" | translate }}
                </button>
            </div>
        </div>
    </div>
</div>